import Vue from "vue"
import App from './App.vue'
import store from './store/store'
import router from './router'
import jQuery from "jquery";
import OtpInput from "@bachdgvn/vue-otp-input";

window.$ = window.jQuery = jQuery;
import "popper.js";
import "bootstrap";
import Axios from "axios";
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect'
import VueHtmlToPaper from 'vue-html-to-paper';
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faUserSecret,
    faTrash,
    faColumns,
    faCaretRight,
    faCaretLeft,
    faIdCard,
    faSearchPlus,
    faPlusCircle,
    faMinusCircle,
    faDownload,
    faSearch
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Validator } from './validation';
import "./assets/app.scss";
import VueCookies from 'vue-cookies';

/////////
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import 'vue-good-table/dist/vue-good-table.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)







import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
/////////

import VueGoodTablePlugin from 'vue-good-table';



Vue.use(VueGoodTablePlugin);


// import the styles


// register globally

Vue.component('multiselect', Multiselect);
Vue.component('paginate', Paginate);
Vue.component("v-otp-input", OtpInput);

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
};

Vue.use(VueHtmlToPaper, options);

library.add(faDownload,faUserSecret, faTrash, faColumns, faCaretRight, faCaretLeft, faIdCard, faSearchPlus, faPlusCircle, faMinusCircle, faSearch);

window.Vue = Vue;

Vue.component('font-awesome-icon', FontAwesomeIcon);

export const HTTP = Axios.create({
  baseURL : process.env.VUE_APP_API_URL + 'api',
  timeout: 14000000000
});

HTTP.interceptors.request.use(function(config) {
    let token = VueCookies.get("token")
    config.headers.common['Authorization'] = token? "Bearer " + token : null;
    return config;
});

HTTP.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
      if (error.response.data.responseData) {
        if (error.response.data.responseData.notVerified) {
          store.dispatch('logout');
          router.push({name: 'login', query: { notVerified: 'true' }});
        } else {
          store.dispatch('logout');
          router.push({name: 'login',  query: { sessionExpired: 'true' }});
        }
      } else {
          store.dispatch('logout');
          router.push({name: 'login',  query: { sessionExpired: 'true' }});
      }
        return;
    } else if (error.response.status >= 500) {
        if (store.getters.userRole === 'ROLE_ADMIN' || store.getters.userRole === 'ROLE_SUPERADMIN') {
            router.push({name: 'admin-dashboard'})
        } else {
            router.push({name: 'user-dashboard'})
        }
     }
    return Promise.reject(error);
});


Vue.prototype.$http = HTTP;
Vue.prototype.$validator = Validator;

Vue.config.productionTip = false;

if (process.env.VUE_APP_PROFILE === 'dev') {
    Vue.config.devtools = true;
} else {
    Vue.config.devtools = false;
}

new Vue({

  router,
  store,
  render: h => h(App)
}).$mount('#app')

